import React, { createContext, useContext, useReducer } from 'react';

export const StoreContext = createContext([])

export const Store = ({ children, reducer, initialState }) => {
    return (
        <StoreContext.Provider value={useReducer(reducer, initialState)}>
            {children}
        </StoreContext.Provider>
    )
}

export const useStore = () => useContext(StoreContext)